import React, { memo } from 'react';
import PropTypes from 'prop-types';

const EDDUIError = memo(props => {
  const { title, description, setShowError, show } = props;

  return show ? (
    <div
      className="h-screen w-screen fixed top-0 left-0 flex justify-center items-center transition-all duration-1000 ease-in-out"
      style={{ zIndex: 1001 }}
    >
      <button
        type="button"
        aria-label="Close error"
        className="absolute inset-0 w-full h-full backdrop-blur-sm border-none bg-transparent cursor-pointer"
        onClick={() => setShowError(false)}
      />
      <div className="w-[400px] h-[400px] 2xl:-translate-y-1/2 relative bg-white rounded-md z-50 shadow-2xl opacity-100 duration-1000 ease-in-out">
        <div className="flex justify-end">
          <button
            type="button"
            className="cursor-pointer transition-transform duration-700 hover:rotate-90 hover:text-primary text-dark-night"
            onClick={e => {
              setShowError(false);
              props.errorAction();
              e.stopPropagation();
            }}
          >
            <i className="material-icons text-[24px] m-4 !text-inherit">close</i>
          </button>
        </div>
        <div className="flex justify-center">
          <i className="material-icons text-[24px] !text-red-600">error_outline</i>
        </div>

        <h2 id="error-title" className=" mt-2 font-medium text-lg text-center text-red-500">
          {title}
        </h2>
        <p
          id="error-description"
          className="text-sm mt-4 text-dark-night supported-files text-center pl-8 pr-8"
          data-test="edd-error-description"
        >
          {description}
        </p>

        <div className="flex flex-col justify-center items-center mt-16 " />

        <div className="flex justify-center pb-4  mt-8">
          <button
            id="error-action-button"
            data-test="error-ok"
            type="button"
            className="bg-primary hover:scale-x-105 hover:scale-y-105 transition duration-500 z-30 shadow-md  w-32 h-12 rounded-lg text-white text-sm font-bold px-2"
            onClick={e => {
              setShowError(false);
              props.errorAction();
              e.stopPropagation();
            }}
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  ) : null;
});

EDDUIError.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  setShowError: PropTypes.func,
  show: PropTypes.bool,
  errorAction: PropTypes.func,
};

export default EDDUIError;
